import { useState } from 'react'

import { Tabs } from '@loadsmart/loadsmart-ui'

import { plural } from 'core/utils/string'

import { type BulkRate } from '../../domain/BulkRate'
import { type DraftQuote } from '../../domain/DraftQuote'
import { type AccessorialHistoryCharge } from '../../domain/QuoteAccessorial'
import { BulkSpotQuotePendingTab } from './BulkSpotQuotePendingTab'
import { BulkSpotQuoteTab } from './BulkSpotQuoteTab'

export type BulkSpotQuoteTabsProps = {
  id: string
  pendingRates: BulkRate[]
  submittedRates: BulkRate[]
  expiredRates: BulkRate[]
  disabled?: boolean
  accessorialsHistory?: Array<AccessorialHistoryCharge>
  onSubmit: (quotes: Array<DraftQuote>) => void
}

export function BulkSpotQuoteTabs({
  id,
  pendingRates,
  submittedRates,
  expiredRates,
  disabled = false,
  accessorialsHistory,
  onSubmit,
}: BulkSpotQuoteTabsProps) {
  const [activeTab, setAciveTab] = useState<string>('pending')

  function handleGoToPendingTab() {
    setAciveTab('pending')
  }

  return (
    <Tabs direction="horizontal" activeTab={activeTab} onTabChange={tab => setAciveTab(tab)}>
      <Tabs.Items>
        <Tabs.Item name="pending">Pending ({pendingRates.length})</Tabs.Item>
        <Tabs.Item name="submitted">Submitted ({submittedRates.length})</Tabs.Item>
        <Tabs.Item name="expired">Expired ({expiredRates.length})</Tabs.Item>
      </Tabs.Items>
      <Tabs.Panels>
        <Tabs.Panel name="pending">
          <BulkSpotQuotePendingTab
            id={id}
            pendingRates={pendingRates}
            disabled={disabled}
            onSubmit={onSubmit}
            accessorialsHistory={accessorialsHistory}
          />
        </Tabs.Panel>
        <Tabs.Panel name="submitted">
          <BulkSpotQuoteTab
            id={id}
            header={`${submittedRates.length} ${plural(
              'lane',
              submittedRates.length
            )} with submitted bids`}
            emptyMessage="You don't have submitted bids"
            rates={submittedRates}
            onSubmit={onSubmit}
            onGoToPendingTab={handleGoToPendingTab}
          />
        </Tabs.Panel>
        <Tabs.Panel name="expired">
          <BulkSpotQuoteTab
            id={id}
            header={`${expiredRates.length} expired ${plural('lane', expiredRates.length)}`}
            emptyMessage="You don't have expired bids"
            rates={expiredRates}
            onGoToPendingTab={handleGoToPendingTab}
          />
        </Tabs.Panel>
      </Tabs.Panels>
    </Tabs>
  )
}
